<template>
    <div class="mt-4 relative">
      <div class="d-flex justify-content-center spacing">
        <div class="title">{{ title }}  </div>
      </div>
  
      <b-container>
        <b-row>
          <b-col  sm="12" lg="6" >
            <span class="text-style" :class="szja < 0 ? 'negative-value' : ''">SZJA</span>
          </b-col>
          <b-col class="text-left text-xl-right" sm="12" lg="6">
            <input v-if="editable"
              :value="szja"
              @blur="$emit('update:szja', $event.target.value); $emit('saveMonthlyData')" 
              class="w-100"/>
            <span  v-else class="text-style  text-lg-right" :class="szja < 0 ? 'negative-value' : ''">{{
              Number(szja).toLocaleString("hu-HU") + " Ft"
            }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col  sm="12" lg="6" >
            <span translate="no" class="text-style" :class="tb < 0 ? 'negative-value' : ''">TB&#8203;</span>
          </b-col>
          <b-col class="text-left text-lg-right" sm="12" lg="6">
            <input v-if="editable" 
              :value="tb"
              @blur="$emit('update:tb', $event.target.value); $emit('saveMonthlyData')" 
              class="w-100"/>
            <span v-else class="text-style text-lg-right" :class="tb < 0 ? 'negative-value' : ''">{{
              Number(tb).toLocaleString("hu-HU") + " Ft"
            }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="6">
            <span class="text-style" :class="szocho < 0 ? 'negative-value' : ''">Szochó</span>
          </b-col>
          <b-col  sm="12" lg="6" class="text-left text-lg-right">
            <input v-if="editable" 
              :value="szocho"
              @blur="$emit('update:szocho', $event.target.value); $emit('saveMonthlyData')" 
              class="w-100"/>

            <span v-else class="text-style text-lg-right" :class="szocho < 0 ? 'negative-value' : ''">{{
              Number(szocho).toLocaleString("hu-HU") + " Ft"
            }}</span>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "AtalanyPaidCard",
    props: ["title", "szja", "tb", "szocho", "editable"],
  
  };
  </script>
  
  <style scoped>
  .card-body {
    width: 100%;
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
  
  .title {
    font-family: Jumper;
    color: #252734;
    font-size: 1.6rem;
    text-align: center;
    width: 100%;
  }
  
  .fa-copy {
    font-size: 1.2rem;
    margin: 0 0 0.2rem 0.2rem;
    color: #d8d8d7;
    cursor: pointer;
  }
  
  .text-style {
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
  }
  
  @media screen and (max-width: 1246px) {
    .text-style  {
      font-size: 30px;
    }
  }

  .spacing {
    margin-bottom: 20px;
  }

  .negative-value {

    color: #F88379;
  }

  input {
    padding: 0px !important;
    box-shadow: none !important;
    text-align: right;
    padding: 8px !important;
    font-size: 11px !important;
  }
  </style>